import React from 'react';
import PropTypes from 'prop-types';
import formatCurrency from '~shared/utils/currencyUtils';

const Currency = ({ value, locale, currency, withCurrencySymbol, withThousandSeperator, decimalPlaces }) => {
    const formattedCurrency = formatCurrency(value, currency, locale, withCurrencySymbol, withThousandSeperator, decimalPlaces);

    return (
        <span
            itemProp="amount"
            itemScope="itemscope"
            itemType="http://schema.org/MonetaryAmount"
            dir="auto"
        >
            <meta itemProp="currency" content={currency} />
            <meta itemProp="value" content={value} />
            <data value={value}
                data-currency={currency}
                data-locale={locale}>
                {formattedCurrency}
            </data>
        </span>
    );
};

Currency.propTypes = {
    value: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
    ]),
    locale: PropTypes.string,
    currency: PropTypes.string,
    withCurrencySymbol: PropTypes.bool,
    withThousandSeperator: PropTypes.bool,
    decimalPlaces: PropTypes.number,
};

Currency.defaultProps = {
    value: '',
    locale: null,
    currency: null,
    withCurrencySymbol: true,
    withThousandSeperator: true,
};

export default Currency;
